import script from "./CollectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectPage.vue?vue&type=script&setup=true&lang=js"

import "./CollectPage.vue?vue&type=style&index=0&id=ba127cc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba127cc6"]])

export default __exports__